<template>
  <v-app class="app-tabela mt-3">
    <div class="box" style="margin-top: 0px">
      <adicionar-equipe></adicionar-equipe>

      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          class="elevation-1"
          show-expand
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="8">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>Parâmetro</th>
                    <th>Cadastros e-SUS</th>
                    <th>Máximo</th>
                    <th>Atenção</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="d-block mb-2">
                        {{ item.min_cad }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ item.cadastros_esus }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ item.max_cad }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ item.recomendacao_cadastro }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} equipes</span
            >
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import AdicionarEquipe from './AdicionarEquipe.vue'

export default {
  name: 'TabelaPessoasPorEquipe',
  components: {
    ShowHideField,
    AdicionarEquipe,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'cnes',
        },
        {
          text: 'UBS',
          align: 'start',
          filterable: true,
          value: 'no_ubs',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'ine',
        },
        {
          text: 'EQUIPE',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'Tipo',
          align: 'start',
          filterable: true,
          value: 'tipo_equipe',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros.map((item, index) => {
          return {
            id: index,
            ...item,
          }
        })
      }
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      let color = ''
      if (Number(item.cadastros_esus) < Number(item.min_cad)) {
        color = 'orange'
      } else if (
        Number(item.cadastros_esus) >= Number(item.min_cad) &&
        Number(item.cadastros_esus) <= Number(item.max_cad)
      ) {
        color = 'green'
      } else {
        color = 'red'
      }
      return `table-row-color-${color}`
    },
  },
}
</script>

<style></style>

<style scoped lang="scss"></style>
